import { memo as Memo, useRef, useEffect, useMemo, useCallback, cloneElement } from 'react';

//* HOCs
import { withUIContext } from 'context';

//* Components
import Icon from 'components/common/Icon';

//* Style
import PopupStyle from './style';

const Popup = Memo(({ closePopup, popupIsOpen, popupComponent }) => {
	const childRef = useRef();

	const Child = useMemo(() => typeof popupComponent === 'string' && components[popupComponent] && components[popupComponent], [popupComponent]);

	useEffect(() => {
		window.addEventListener('keydown', handleKeydown);

		return () => {
			window.removeEventListener('keydown', handleKeydown);
		};
	}, []);

	const closeHandler = useCallback(() => {
		if (childRef?.current?.handleClose) {
			childRef.current.handleClose();
		} else {
			closePopup();
		}
	}, []);

	const handleKeydown = useCallback(
		(e) => {
			if (e.key === 'Escape') {
				popupComponent && closeHandler();
			}
		},
		[popupComponent]
	);

	return popupIsOpen ? (
		<PopupStyle>
			<div
				className='popup-background'
				onClick={closeHandler}
			/>
			<div className='popup-content-container'>
				<div className='popup-content-wrap'>
					<div
						className='close'
						onClick={closeHandler}>
						<Icon
							name={'close'}
							className={'close-btn-icon'}
						/>
					</div>
					{typeof popupComponent === 'string' ? (
						<Child ref={childRef} />
					) : (
						cloneElement(popupComponent, {
							ref: childRef,
							closeHandler,
							closePopup,
						})
					)}
				</div>
			</div>
		</PopupStyle>
	) : null;
});

export default withUIContext(Popup, ['closePopup', 'popupIsOpen', 'popupComponent']);
